// extracted by mini-css-extract-plugin
module.exports = {"Heading":"IntegrationFeed_Heading__1A9Q2"};